import { FlexBox, SocialLink, marginEdgesRules } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { Book } from '@fable/types'
import { Page } from 'components/Page'
import { PersonCard } from './PersonCard'
import { PersonInfo } from './PersonInfo'

export interface Props {
  name: string
  image: string
  biography: React.ReactNode
  role?: string
  books?: Book[]
  socialLinks?: SocialLink[]
  seoTitle?: string
  seoDescription: string
  hideShareButton?: boolean
}

export const PersonDetailContent = ({
  name,
  biography,
  image,
  books,
  role,
  socialLinks,
  seoTitle,
  seoDescription,
  hideShareButton = false,
}: Props) => {
  const { mediaQueries } = useTheme()

  return (
    <Page
      className={cx(
        css`
          padding: 0;
          ${mediaQueries.mobileL} {
            padding: 0 ${marginEdgesRules.tablet};
          }
          ${mediaQueries.tabletL} {
            padding: 0 ${marginEdgesRules.desktop};
          }
        `,
        'fade'
      )}
      head={{
        title: seoTitle || name,
        description: seoDescription,
        image: image,
        canonical: true,
        isTitleStrict: !!seoTitle,
      }}
    >
      <FlexBox
        className={css`
          flex-direction: column;
          ${mediaQueries.tabletL} {
            flex-direction: row;
            align-items: stretch;
            height: calc(100vh - 60px);
            @media only screen and (max-height: 800px) {
              height: 740px;
            }
          }
        `}
        gap="24px"
      >
        <PersonCard
          name={name}
          image={image}
          hideShareButton={hideShareButton}
          role={role}
          socialLinks={socialLinks}
        />
        <PersonInfo name={name} biography={biography} books={books} />
      </FlexBox>
    </Page>
  )
}
